var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlienci(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#c9c9c9",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44.979 44.979",
    xmlSpace: "preserve",
    stroke: "#c9c9c9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.502,17.371c-0.002,0-11.213-0.004-12.011-0.004c0,0-0.005,0-0.006,0c-1.021,0-1.853,0.846-1.85,1.867l0.04,11.565 c0.004,1.018,0.83,1.863,1.845,1.863c0.002,0,0.005,0,0.007,0c0.574,0,1.086-0.287,1.423-0.701l0.729,11.256 c0.064,1.006,0.9,1.762,1.909,1.762h3.804c1.008,0,1.842-0.767,1.908-1.772l0.727-11.276c0.338,0.438,0.849,0.731,1.425,0.731 c0.002,0,0.003,0,0.007,0c1.016,0,1.841-0.86,1.848-1.871l0.037-11.544C30.347,18.235,29.522,17.371,28.502,17.371z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.491,
    cy: 11.022,
    r: 5.115
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.14,9.006c-0.001,0-8.809-0.003-9.435-0.003c0,0-0.004,0-0.005,0c-0.801,0-1.455,0.665-1.453,1.467l0.031,9.085 c0.003,0.8,0.652,1.464,1.45,1.464c0.001,0,0.004,0,0.005,0c0.451,0,0.854-0.225,1.118-0.55l0.573,8.841 c0.051,0.789,0.707,1.383,1.5,1.383h2.989c0.791,0,1.446-0.602,1.499-1.391l0.57-8.859c0.266,0.343,0.667,0.575,1.12,0.575 c0.001,0,0.002,0,0.005,0c0.798,0,1.446-0.677,1.451-1.47l0.03-9.07C12.589,9.685,11.941,9.006,11.14,9.006z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.418,
    cy: 4.018,
    r: 4.018
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.839,9.006c0.001,0,8.809-0.003,9.436-0.003h0.004c0.802,0,1.455,0.665,1.453,1.467l-0.03,9.085 c-0.003,0.8-0.652,1.464-1.45,1.464c-0.001,0-0.004,0-0.005,0c-0.451,0-0.854-0.225-1.118-0.55l-0.572,8.841 c-0.052,0.789-0.707,1.383-1.5,1.383h-2.99c-0.791,0-1.445-0.602-1.498-1.391l-0.57-8.859c-0.266,0.343-0.667,0.575-1.12,0.575 c-0.001,0-0.002,0-0.005,0c-0.799,0-1.447-0.677-1.451-1.47l-0.029-9.07C32.39,9.685,33.038,9.006,33.839,9.006z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.562,
    cy: 4.018,
    r: 4.018
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlienci);
export default __webpack_public_path__ + "static/media/klienci.15a8cc3b4b0d211c3392b4bf6e802c62.svg";
export { ForwardRef as ReactComponent };